var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.labels)?_c('div',[_c('AreaChart',{key:((_vm.datesrange[0]) + "+" + (_vm.datesrange[1]) + "+" + _vm.datesrangetype + "+'10'"),attrs:{"chartData":_vm.chartdata,"chartoptions":_vm.chartoptions}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }